import React, { useState } from 'react';

export default function VendorPortal() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const orderData = [
    { id: 'ORD-001', product: 'Diamond Ring Set', quantity: 2, value: '₹2,50,000', status: 'confirmed', dueDate: '2024-02-15' },
    { id: 'ORD-002', product: 'Gold Chain Collection', quantity: 5, value: '₹1,80,000', status: 'in_progress', dueDate: '2024-02-20' },
    { id: 'ORD-003', product: 'Pearl Necklace', quantity: 1, value: '₹85,000', status: 'quality_check', dueDate: '2024-02-10' },
  ];

  const paymentData = [
    { id: 'PAY-001', order: 'ORD-001', amount: '₹1,25,000', status: 'paid', date: '2024-01-15' },
    { id: 'PAY-002', order: 'ORD-002', amount: '₹90,000', status: 'pending', date: '2024-01-20' },
    { id: 'PAY-003', order: 'ORD-003', amount: '₹42,500', status: 'processing', date: '2024-01-18' },
  ];

  const performanceMetrics = [
    { title: 'Total Orders', value: '156', change: '+12%' },
    { title: 'Completed Orders', value: '142', change: '+8%' },
    { title: 'On-Time Delivery', value: '94%', change: '+2%' },
    { title: 'Quality Rating', value: '4.8/5', change: '+0.2' },
  ];

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-primary">Vendor Portal</h1>
        <div className="flex gap-3">
          <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-upload-line mr-2"></i>
            Submit Product
          </button>
          <button className="border border-primary text-primary px-4 py-2 rounded-lg hover:bg-primary/5 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-message-line mr-2"></i>
            Support
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="flex space-x-8">
          {[
            { id: 'dashboard', label: 'Dashboard', icon: 'ri-dashboard-line' },
            { id: 'orders', label: 'Orders', icon: 'ri-shopping-bag-line' },
            { id: 'products', label: 'Products', icon: 'ri-product-hunt-line' },
            { id: 'payments', label: 'Payments', icon: 'ri-money-rupee-circle-line' },
            { id: 'performance', label: 'Performance', icon: 'ri-bar-chart-line' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <i className={`${tab.icon} mr-2`}></i>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Dashboard Tab */}
      {activeTab === 'dashboard' && (
        <div className="space-y-6">
          {/* Performance Metrics */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {performanceMetrics.map((metric, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">{metric.title}</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{metric.value}</p>
                    <p className="text-sm text-green-600 mt-1">{metric.change}</p>
                  </div>
                  <div className="p-3 bg-primary/10 rounded-lg">
                    <i className="ri-trophy-line text-primary text-xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Recent Activity */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Recent Orders</h2>
              <div className="space-y-3">
                {orderData.slice(0, 3).map((order) => (
                  <div key={order.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <h3 className="font-semibold text-gray-900">{order.id}</h3>
                      <p className="text-sm text-gray-600">{order.product}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-medium text-gray-900">{order.value}</p>
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        order.status === 'confirmed' ? 'bg-green-100 text-green-800' :
                        order.status === 'in_progress' ? 'bg-blue-100 text-blue-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {order.status.replace('_', ' ')}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Payment Status</h2>
              <div className="space-y-3">
                {paymentData.slice(0, 3).map((payment) => (
                  <div key={payment.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <h3 className="font-semibold text-gray-900">{payment.order}</h3>
                      <p className="text-sm text-gray-600">{payment.date}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-medium text-gray-900">{payment.amount}</p>
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        payment.status === 'paid' ? 'bg-green-100 text-green-800' :
                        payment.status === 'pending' ? 'bg-red-100 text-red-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {payment.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Orders Tab */}
      {activeTab === 'orders' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h2 className="text-xl font-semibold text-primary">Order Management</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Order ID</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Product</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Quantity</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Value</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Status</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Due Date</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Actions</th>
                </tr>
              </thead>
              <tbody>
                {orderData.map((order) => (
                  <tr key={order.id} className="border-t">
                    <td className="px-6 py-4 font-medium">{order.id}</td>
                    <td className="px-6 py-4">{order.product}</td>
                    <td className="px-6 py-4">{order.quantity}</td>
                    <td className="px-6 py-4 font-medium">{order.value}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        order.status === 'confirmed' ? 'bg-green-100 text-green-800' :
                        order.status === 'in_progress' ? 'bg-blue-100 text-blue-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {order.status.replace('_', ' ')}
                      </span>
                    </td>
                    <td className="px-6 py-4">{order.dueDate}</td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                        <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                          <i className="ri-eye-line"></i>
                        </button>
                        <button className="text-green-600 hover:text-green-800 cursor-pointer">
                          <i className="ri-edit-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Products Tab */}
      {activeTab === 'products' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b flex justify-between items-center">
            <h2 className="text-xl font-semibold text-primary">Product Catalog</h2>
            <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-add-line mr-2"></i>
              Add Product
            </button>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <div key={item} className="border rounded-lg p-4">
                  <div className="aspect-square bg-gray-200 rounded-lg mb-3 flex items-center justify-center">
                    <i className="ri-image-line text-gray-400 text-2xl"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900">Product {item}</h3>
                  <p className="text-sm text-gray-600 mt-1">Category: Ring</p>
                  <p className="text-sm text-gray-600">Status: Active</p>
                  <div className="flex justify-between items-center mt-3">
                    <span className="font-medium text-primary">₹45,000</span>
                    <div className="flex gap-2">
                      <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                        <i className="ri-edit-line"></i>
                      </button>
                      <button className="text-red-600 hover:text-red-800 cursor-pointer">
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Payments Tab */}
      {activeTab === 'payments' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h2 className="text-xl font-semibold text-primary">Payment History</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Payment ID</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Order</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Amount</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Status</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Date</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Actions</th>
                </tr>
              </thead>
              <tbody>
                {paymentData.map((payment) => (
                  <tr key={payment.id} className="border-t">
                    <td className="px-6 py-4 font-medium">{payment.id}</td>
                    <td className="px-6 py-4">{payment.order}</td>
                    <td className="px-6 py-4 font-medium">{payment.amount}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        payment.status === 'paid' ? 'bg-green-100 text-green-800' :
                        payment.status === 'pending' ? 'bg-red-100 text-red-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {payment.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">{payment.date}</td>
                    <td className="px-6 py-4">
                      <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                        <i className="ri-download-line"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Performance Tab */}
      {activeTab === 'performance' && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Performance Metrics</h2>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-3 border-b">
                  <span className="text-gray-600">Order Completion Rate</span>
                  <span className="font-semibold text-green-600">94%</span>
                </div>
                <div className="flex justify-between items-center p-3 border-b">
                  <span className="text-gray-600">Average Delivery Time</span>
                  <span className="font-semibold">12 days</span>
                </div>
                <div className="flex justify-between items-center p-3 border-b">
                  <span className="text-gray-600">Quality Rating</span>
                  <span className="font-semibold text-yellow-600">4.8/5</span>
                </div>
                <div className="flex justify-between items-center p-3">
                  <span className="text-gray-600">Customer Satisfaction</span>
                  <span className="font-semibold text-green-600">96%</span>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Monthly Revenue</h2>
              <div className="space-y-3">
                {['Jan', 'Feb', 'Mar', 'Apr', 'May'].map((month, index) => (
                  <div key={month} className="flex items-center justify-between">
                    <span className="text-gray-600">{month} 2024</span>
                    <div className="flex items-center gap-3">
                      <div className="w-20 bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-primary h-2 rounded-full"
                          style={{ width: `${60 + index * 8}%` }}
                        ></div>
                      </div>
                      <span className="font-medium">₹{(15 + index * 3).toFixed(1)}L</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}